import { useCallback, useEffect } from 'react'
import { useSelector } from 'react-redux';
import './style.css'

const CloseWarning = () => { 

    const isNew = useSelector( state => state.board.isNew );

    /**
     * @name handleClose
     * @function
     * @description 
     */
    const handleClose = useCallback( e => {
        e.preventDefault();
        e.returnValue = '';
    }, []);

    // watch to see if we should prevent reload if the user hasn't saved
    useEffect(() => {

        if( !isNew ){
            window.addEventListener( 'beforeunload', handleClose, true );
        } else {
            window.removeEventListener( 'beforeunload', handleClose, true );
        }

        return () => {
            window.removeEventListener( 'beforeunload', handleClose, true );
        }

    }, [ isNew, handleClose ]);

    return null

}

export default CloseWarning